import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_chevron_down, l_chevron_up } from '@fiverr-private/fit/icons';
import { numberFormat } from '@fiverr-private/localization';
import Comment from '../Comment';
import Replies from '../Replies';
import * as CommentsSelectors from '../../selectors/comments';
import * as FilerrsSelectors from '../../selectors/filerrs';
import * as FilesSelectors from '../../selectors/files';
import * as CurrentsSelectors from '../../selectors/current';
import * as CurrentsActions from '../../actions/current';
import * as Translations from '../../providers/i18n';
import './style.scss';

export class FileComments extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldShowComment: props.shouldShowComment
        };

        this.toggleComments = this.toggleComments.bind(this);
        this.defaultOpen = this.defaultOpen.bind(this);
        this.selectFile = this.selectFile.bind(this);
    }

    componentDidUpdate(prevProps) {
        const {
            currentFileId,
            fileId,
            commentIds
        } = this.props;

        if (prevProps.currentFileId !== currentFileId && fileId === currentFileId) {
            this.defaultOpen();
        }

        if (prevProps.commentIds.length < commentIds.length) {
            this.defaultOpen();
        }
    }

    defaultOpen() {
        this.setState({
            shouldShowComment: true
        });
    }

    toggleComments(e) {
        e.stopPropagation();

        this.setState({
            shouldShowComment: !this.state.shouldShowComment
        });
    }

    selectFile() {
        const {
            setCurrentFileId,
            setCurrentFilerrId,
            setCurrentCommentId,
            setCurrentTimecode,
            fileId,
            filerrId
        } = this.props;

        setCurrentFileId(fileId);
        setCurrentFilerrId(filerrId);
        setCurrentCommentId(undefined);
        setCurrentTimecode(undefined);
    }

    render() {
        const {
            commentIds,
            fileName,
            currentFileId,
            fileId,
            isRevisionRequest,
            areTherePendingComments,
            i18n
        } = this.props;

        const { shouldShowComment } = this.state;

        if (!commentIds.length && currentFileId !== fileId) {
            return null;
        }

        if (!areTherePendingComments && !isRevisionRequest) { return null; }
        if (!commentIds.length && isRevisionRequest) { return null; }

        const shouldShowCommentsCount = !!commentIds.length;

        const headerClasses = classNames('file-comments-header font-accent', {
            selected: currentFileId === fileId,
            revision: isRevisionRequest
        });

        const wrapperClasses = classNames('file-comments-wrapper', { revision: isRevisionRequest });
        const formattedCommentsLength = numberFormat(commentIds.length, {
            fallbackValue: commentIds.length
        });

        return (
            <div className={wrapperClasses} id={`file-comment-${fileId}`}>
                <div className={headerClasses} onClick={this.selectFile}>
                    <span className="file-name">{fileName}</span>
                    {shouldShowCommentsCount && <div>
                        <span>{i18n.t('attachments_preview.collaboration.comments.file_comments', { count: formattedCommentsLength })}</span>
                        {!isRevisionRequest && <Icon className="file-chevron" size={8} onClick={this.toggleComments}>{shouldShowComment ? l_chevron_up : l_chevron_down}</Icon>}
                    </div>}
                </div>
                {shouldShowComment && commentIds.map((commentId, index) => (
                    <li key={index}>
                        <Comment commentId={commentId} isRevisionRequest={isRevisionRequest}/>
                        <Replies commentId={commentId} isRevisionRequest={isRevisionRequest}/>
                    </li>
                ))}
            </div>
        );
    }
}

FileComments.defaultProps = {
    shouldShowComment: true,
    commentIds: [],
    fileName: '',
    currentFileId: '',
    fileId: '',
    filerrId: '',
    setCurrentFileId: () => null,
    setCurrentFilerrId: () => null,
    setCurrentCommentId: () => null,
    setCurrentTimecode: () => null,
    isRevisionRequest: false
};

FileComments.propTypes = {
    shouldShowComment: PropTypes.bool,
    commentIds: PropTypes.array,
    fileName: PropTypes.string,
    currentFileId: PropTypes.string,
    fileId: PropTypes.string,
    filerrId: PropTypes.string,
    setCurrentFileId: PropTypes.func,
    setCurrentFilerrId: PropTypes.func,
    setCurrentCommentId: PropTypes.func,
    setCurrentTimecode: PropTypes.func,
    isRevisionRequest: PropTypes.bool,
    areTherePendingComments: PropTypes.bool,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state, { fileId, isRevisionRequest }) => {
    const filerrId = FilesSelectors.getFilerrIdByFileId(state, fileId);

    return {
        commentIds: CommentsSelectors.getCommentIdsWithoutRepliesByFileId(state, fileId, isRevisionRequest),
        fileName: FilerrsSelectors.getFileNameById(state, filerrId),
        currentFileId: CurrentsSelectors.getCurrentFileId(state),
        fileId,
        filerrId,
        areTherePendingComments: CommentsSelectors.shouldShowCommentsByFileId(state, fileId)
    };
};

export default compose(
    Translations.connect,
    connect(mapStateToProps, {
        setCurrentFileId: CurrentsActions.setCurrentFileId,
        setCurrentFilerrId: CurrentsActions.setCurrentFilerrId,
        setCurrentCommentId: CurrentsActions.setCurrentCommentId,
        setCurrentTimecode: CurrentsActions.setCurrentTimecode
    }))(FileComments);
